const selectMapRegions = state => state.data.mapRegions

const MapRegionDataStoreSelectors = {
  mapRegions: selectMapRegions
}

export default MapRegionDataStoreSelectors
